import { Connection } from '@wix/cms-viewer-core'
import { BindingKeyManager } from '@wix/binding-key-manager'

export const adaptBuilderConnection = (builderConnection) => {
  const properties = Object.fromEntries(
    Object.entries(builderConnection.byItem).map(
      ([bindingKey, { config: { dataType, fieldKey, format, parentDataType } }]) => {
        const {
          id: propertyName,
          subItemId: subropertyName,
        } = BindingKeyManager.decode(bindingKey)
        const propertyPath = typeof subropertyName === 'undefined'
          ? propertyName
          : `${propertyName}.${subropertyName}`

        return [
          propertyPath,
          Connection.makePropertyConnectionToField({
            fieldKey,
            format,
            outputType: dataType === 'text' || dataType === 'richText' || parentDataType
              ? 'text' : 'unknown',
          }),
        ]
      },
    ),
  )

  const linkBindingKey = BindingKeyManager.encode([], { type: 'dataItem', id: 'link' })
  const { [linkBindingKey]: { config: { data } } = { config: {} } } = builderConnection.byItem

  return Connection.make({ properties, data })
}
